export const CONFIG = {
    DEFAULT_PAGE_CONFIG: {
        appName: `Let's connect`,
        appVersion: process.env.PACKAGE_VERSION
    },
    CDN_BASE_URL: `https://cdn.public.initia-digital.co.nz`,
    CURRENT_EVENT: 'ICT Grad School - Speed Networking September 25',
    IS_FORM_OPEN: false
}